import { useState } from "react";
import { Container, Card } from "react-bootstrap";
import { Row, Col, Form, Input, Select, message } from "antd";
import { AnimatePresence, motion } from "framer-motion";

import moment from "moment";
import Button from "antd-button-color";

import { formatNumber } from "lib/utility";
import { productLists } from "data/product";

import "./style.css";

const CheckoutContainer = () => {
  const [showDetail, setShowDetail] = useState(false);

  return (
    <>
      <Container>
        <h4 className="fs-20 mb-3 pt-3">Checkout</h4>
        <Row gutter={[16, 16]}>
          <Col xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
            <p className="fw-500 fs-16 mb-0">Data Pengiriman</p>
            <hr className="my-2" />
            <Form layout="vertical">
              <Row gutter={[16, 16]}>
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                  <Form.Item label="Label Alamat" className="mb-0">
                    <Input placeholder="Rumah, Kantor, Apartemen" />
                  </Form.Item>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                  <Form.Item label="Nama Penerima" className="mb-0">
                    <Input placeholder="Nama Penerima" />
                  </Form.Item>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                  <Form.Item label="Nomor Telepon" className="mb-0">
                    <Input placeholder="Nomor Telepon" prefix="+62" />
                  </Form.Item>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                  <Form.Item label="Kurir Pengiriman" className="mb-0">
                    <Select value="1" placeholder="Kurir Pengiriman">
                      <Select.Option value="1">Karya Nadhi Logistics</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Kabupaten" className="mb-0">
                    <Input placeholder="Kabupaten" />
                  </Form.Item>
                </Col>
                {/* <Col xxl={18} xl={18} lg={18} md={18} sm={18} xs={18}> */}
                <Col span={18}>
                  <Form.Item label="Kota atau Kecamatan" className="mb-0">
                    <Input placeholder="Tulis Nama Alamat / Kota / Kecamatan tujuan pengiriman" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="Kode Pos" className="mb-0">
                    <Input placeholder="Kode Pos" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Alamat Penerima" className="mb-0">
                    <Input.TextArea placeholder="Alamat Penerima" />
                  </Form.Item>
                </Col>
              </Row>
            </Form>

            <h4 className="fs-18 mb-0 mt-5">Daftar Pesanan</h4>
            <div className="border-bottom-5px mb-4 mt-3" />

            {[...Array(10)].map((_, i) => (
              <Row gutter={[16, 16]} className="w-100" key={productLists[i].name}>
                <Col xxl={3} xl={3} lg={4} md={5} sm={5} xs={5}>
                  <img
                    src={`/assets/img/products/${productLists[i].image}`}
                    className="cart-item-img"
                    alt={productLists[i].name}
                  />
                </Col>
                <Col xxl={21} xl={21} lg={20} md={19} sm={19} xs={19}>
                  <h5 className="my-0 fs-12-s fs-16 truncate-2">{productLists[i].name}</h5>
                  <div className="d-block text-muted">
                    <small>{Math.floor(Math.random() * 100) + 1} pcs</small>
                  </div>
                  <div className="d-block text-muted">
                    <small>
                      {moment(new Date()).format("DD MMM YYYY")} -{" "}
                      {moment(new Date())
                        .add(Math.floor(Math.random() * 20) + 1, "days")
                        .format("DD MMM YYYY")}
                      {" ("}
                      {Math.floor(Math.random() * 20) + 1} hari)
                    </small>
                  </div>
                  {productLists[i].discount > 0 ? (
                    <>
                      <div className="product-card-body-price">
                        <small className="text-muted fw-normal text-decoration-line-through m-b-4 me-2">
                          Rp {formatNumber(productLists[i].price)}{" "}
                        </small>
                        Rp{" "}
                        {formatNumber(
                          productLists[i].price -
                            productLists[1].price * (productLists[i].discount / 100)
                        )}
                        <small className="fw-normal text-muted">/hari</small>
                      </div>
                    </>
                  ) : (
                    <div className="product-card-body-price">
                      Rp {formatNumber(productLists[i].price)}
                      <small className="fw-normal text-muted">/hari</small>
                    </div>
                  )}
                </Col>
                <Col span={24}>
                  <div className="d-block text-muted">
                    <small>Catatan: Kursi hitam</small>
                  </div>

                  <hr />

                  <div className="d-block">
                    <b>Subtotal</b>
                    <Button
                      type="link"
                      className="float-end p-0 text-dark"
                      onClick={() => setShowDetail(!showDetail)}
                      style={{ height: 23 }}
                    >
                      Rp 230.000
                      <i className={`far fa-chevron-${showDetail ? "down" : "up"} ms-1`} />
                    </Button>
                  </div>
                  <p className="mb-2" />
                  <AnimatePresence>
                    {showDetail && (
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                      >
                        <div className="d-block">
                          <b>Harga (1 barang)</b>
                          <b className="float-end">Rp 230.000</b>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>

                  <div className="border-bottom-5px mt-3 mb-4" />
                </Col>
              </Row>
            ))}
          </Col>

          <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
            <Card className="checkout-summary payment">
              <Card.Body>
                <p className="fw-bold fs-14">Ringkasan sewaan</p>

                <p className="fw-light checkout-summary-price fs-14 mb-1">
                  Total Harga (2 barang)
                  <span className="float-end cart-item-price fw-bold">Rp. 120.000</span>
                </p>
                <p className="fw-light checkout-summary-price fs-14 mb-1">
                  Total Ongkos Kirim
                  <span className="float-end cart-item-price fw-bold">Rp. 300.000</span>
                </p>
                <hr />
                <p className="fw-bold checkout-summary-price fs-16">
                  Total Tagihan
                  <span className="float-end fw-bold">Rp. 420.000</span>
                </p>

                <Button
                  block
                  type="dark"
                  size="large"
                  onClick={() => message.success("Pop Up midtrans")}
                >
                  Pilih Pembayaran
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CheckoutContainer;
